import { AccountCircle } from "@mui/icons-material";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useVendorContext } from '../../context/VendorContext';

const UserProfileMenu = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { vendor, logout } = useVendorContext();

  const toggleMenu = () => setIsOpen((prev) => !prev);

  // Close menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={toggleMenu}
        className="flex items-center gap-2 bg-slate-300 hover:bg-slate-400 text-gray-800 px-4 py-2 rounded-full transition"
      >
        <AccountCircle className="text-gray-700" fontSize="medium" />
        <span className="text-sm font-medium">
          {vendor?.vendorName ?? 'Vendor'}
        </span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg z-50">
          <ul className="py-1 text-sm text-gray-700">
            <li>
              <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => navigate('/profile')}>
                Profile
              </button>
            </li>
            {/* <li>
              <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
                Settings
              </button>
            </li> */}
            <li>
              <button
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-500"
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserProfileMenu;
